import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';

export const paymentMethods = [
  { label: 'Unknown', value: 'Unknown' },
  { label: 'Automated Clearing House (ACH)', value: 'ACH' },
  { label: 'Cash Concentration/Disbursement plus Addenda (CCD+) (ACH)', value: 'CCD+' },
  { label: 'Corporate Trade Exchange (CTX) (ACH)', value: 'CTX' },
  { label: 'Balance of Payments (BOP)', value: 'BOP' },
  { label: 'Check', value: 'Check' },
  { label: 'Federal Reserve Funds/Wire Transfer - Non Repetitive', value: 'FRF-WT' },
  { label: 'vPayment', value: 'vPayment' },
  { label: 'Non-Payment Data', value: 'Non-Payment' }
];

export const paymentStatusOptions = [
  {
    label: 'Started',
    value: 'started'
  },
  {
    label: 'Cancelled',
    value: 'cancelled'
  },
  {
    label: 'Completed',
    value: 'completed'
  },
  {
    label: 'Approval',
    value: 'APPROVAL'
  },
  {
    label: 'Initiated',
    value: 'initiated'
  },
  {
    label: 'Voided',
    value: 'voided'
  },
  {
    label: 'Failed',
    value: 'failed'
  },
  {
    label: 'Refunded',
    value: 'refunded'
  },
  {
    label: 'Partially Refunded',
    value: 'partially_refunded'
  }
];

export const paymentTypeOptions = [
  'ONLINE',
  'CARD_PRESENT',
  'KIOSK_CARD_PRESENT',
  'COF',
  'cash',
  'check',
  'care_credit',
  'IN_PROGRESS'
].map((value) => ({ label: TYPE_LABELS[value], value }));

export const discountTypes = [
  { label: '$', value: 'amount' },
  { label: '%', value: 'percent' }
];

export const serviceTypes = [
  { value: 'primary', label: 'Insurance' },
  { value: 'self_pay', label: 'Self Pay' },
  { value: 'unapplied', label: 'Unapplied' }
];
